import React, { useRef } from "react";
import { GripVertical } from "lucide-react";
import { useDrag, useDrop } from "react-dnd";

const Sentence = ({ sentence, index, correctIndex, moveSentence, submitted }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: "Sentence",
    hover(item) {
      if (!ref.current || submitted) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      moveSentence(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "Sentence",
    item: { id: sentence.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.4 : 1;

  let stateClass =
    "border-slate-200 bg-white text-gray-700 hover:border-purple-200 hover:bg-purple-50/60";
  if (submitted) {
    stateClass =
      index === correctIndex
        ? "border-green-200 bg-green-50 text-green-800"
        : "border-red-200 bg-red-50 text-red-800";
  }

  if (!submitted) {
    drag(drop(ref));
  }

  return (
    <div
      ref={ref}
      style={{ opacity }}
      className={`flex cursor-move items-start gap-3 rounded-md border p-4 text-sm font-semibold leading-6 shadow-sm transition ${stateClass}`}
    >
      <span className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-md bg-slate-50 text-gray-400 ring-1 ring-slate-100">
        <GripVertical className="h-4 w-4" aria-hidden="true" />
      </span>
      <span>{sentence.options}</span>
    </div>
  );
};

export default Sentence;
